import { useEffect, useState } from "react";
import axios from "axios";
import { NavLink } from "react-router-dom";

// ─── Component ───────────────────────────────────────────────────────────────

const Blog = () => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlogPosts = async () => {
      try {
        const response = await axios.get(
          "https://newsdata.io/api/1/latest?apikey=pub_221745b3737ca9dd83968144054bcf7ed549b&q=crypto&country=au,us&removeduplicate=1&size=10"
          // "https://gnews.io/api/v4/search?q=crypto&lang=en&country=us&max=10&apikey=614497ccec25dcede986d69abd2fcdbf"
        );
        setBlogPosts(response.data.results);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchBlogPosts();
  }, []);

  const formatDate = (iso) =>
    new Date(iso).toLocaleDateString("en-US", {
      month: "long", day: "numeric", year: "numeric",
    });

  return (
    <div className="bg-[#F7F3EC] min-h-screen px-8 py-20">
      <div className="max-w-[800px] mx-auto">

        <p className="text-[0.72rem] font-semibold tracking-[0.16em] uppercase text-[#C4622D] mb-4">
          Latest News
        </p>
        <h2 className="sc-serif text-[clamp(2rem,4vw,3rem)] text-[#1C1A16] leading-[1.1] mb-3">
          Cryptocurrency News
        </h2>
        <p className="text-[#6B6457] text-[0.9rem] mb-14">
          Stay informed with the latest crypto developments
        </p>

        {/* Loading dots */}
        {loading && (
          <div className="flex gap-1.5 mb-8">
            {[0, 150, 300].map((d) => (
              <span
                key={d}
                className="w-2 h-2 rounded-full bg-[#C4622D] animate-bounce"
                style={{ animationDelay: `${d}ms` }}
              />
            ))}
          </div>
        )}

        {/* Article list */}
        <div className="flex flex-col">
          {blogPosts.map((post, i) => (
            <NavLink
              key={i}
              to={post.link}
              className="group grid gap-6 py-7 border-b border-[#E0D9CC] no-underline
                         border-l-[3px] border-l-transparent pl-3
                         hover:border-l-[#C4622D] hover:pl-5 transition-all"
              style={{ gridTemplateColumns: post.image_url ? "1fr 100px" : "1fr" }}
            >
              <div className="flex flex-col justify-between gap-2">
                <div>
                  <p className="text-[0.68rem] font-semibold tracking-[0.1em] uppercase text-[#C4622D] mb-2">
                    {post.source?.name ?? "News"}
                  </p>
                  <h3 className="text-base font-semibold text-[#1C1A16] leading-snug group-hover:text-[#C4622D] transition-colors">
                    {post.title}
                  </h3>
                </div>
                {post.publishedAt && (
                  <p className="text-[0.75rem] text-[#9C9488]">{formatDate(post.publishedAt)}</p>
                )}
              </div>

              {post.image_url && (
                <img
                  src={post.image_url}
                  alt={post.title}
                  className="w-[100px] h-[70px] object-cover shrink-0"
                />
              )}
            </NavLink>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blog;